export enum SubmodelExchangeErrorCodes {
    WRONG_VERSION = "WRONG_VERSION",
    ELEMENTS_DO_NOT_MATCH = "ELEMENTS_DO_NOT_MATCH",
    INVALID_INPUT = "INVALID_INPUT",
}